import { convertDotObjectToNested } from '~/utils/baseUtils';
import { ApiResponseTransformer } from '~/plugins/apiClient/_types';

export const rawToTranslationObject: ApiResponseTransformer<object | null> = (data) => {
    if (data == null) return null;

    return convertDotObjectToNested(data);
    // Ignore BE validation strings
    //return omit(result, ['validation']);
};
